import BreadCrumb from "components/Common/BreadCrumb";
import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import moment from "moment";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from "use-query-params";
import LabelWrapper from "components/Common/LabelWrapper";
import CountUp from "react-countup";
import { getEventLogs } from "store/eventLog/thunk";
import CollapseFilter from "components/Common/CollapseFilter";
import DatePickerCustom from "components/Common/DatePickerCustom";
import DropdownCountries from "components/Common/DropdownCountries";
import DropdownOption from "components/Common/DropdownOption";
import DropdownPlatform from "components/Common/DropdownPlatform";
import ModalPreview from "components/Common/ModalPreview";
import {
  FIND_TALENT_SCREEN_CONST,
  MANAGER_RECRUITMENT_SCREEN_CONST,
  JOB_POST_DETAIL_SCREEN_CONST,
  JOB_POST_SCREEN_CONST,
  PROFILE_JOB_SEEKER_SCREEN_CONST,
  COLOR_USER_TYPE_LOG,
  LIST_OPTION_OS,
  LIST_OPTION_PLATFORM,
  LIST_USER_LOG_TYPE_OPTION,
  ADULT_VERIFICATION_SCREEN_CONST,
  PROFILE_RECRUITMENT_SCREEN_CONST,
  SCREEN_CONST,
  USER_TYPE_LOG_OPTION,
  COMMUNITY_SCREEN_CONST,
  COMMUNITY_DETAIL_SCREEN_CONST,
  PAYMENT_AMOUNT_SCREEN_CONST,
  USER_TYPE_NOTICE_OPTION,
  USER_LOGIN_TYPE_OPTION,
  COLOR_LOGIN_TYPE_LOG,
  SETTING_SCREEN_CONST,
  APP_INFO_SCREEN_CONST,
  FAQ_SCREEN_CONST,
  NOTIFICATION_SETTING_SCREEN_CONST,
  INQUIRY_SCREEN_CONST
} from "helpers/constans";
import { formatDateStringToKorea, formatDateStringToUTC, getPlatFormImage } from "helpers/format";
import { capitalizeFirstLetter } from "utils";
import DropdownStatusNew from "components/Common/DropdownStatusNew";
import countries from "helpers/countries";
import DropdownOptionImage from "components/Common/DropdownOptionImage";
import CopyWrapper from "components/Common/CopyWrapper";
import IPHONE_MODELS from "helpers/iphone_models";
import DropdownOptionMulti from "components/Common/DropdownOptionMulti";
import ModalMultiPreview from "components/Common/ModalMultiPreview";
import noImageJob from "../../assets/images/no-user.png";
import eventLogApi from "api/eventLogApi";

interface Option {
  label: string;
  value: string;
}

registerLocale("en", en);
registerLocale("ko", ko);

const EventLogList = () => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 30),
    // "sort[createdAt]": withDefault(StringParam, `desc`),
    // orderBy: withDefault(StringParam, `DESC`),
    userNickname: withDefault(StringParam, ""),
    phoneNumber: withDefault(StringParam, ""),
    userEmail: withDefault(StringParam, ""),
    address: withDefault(StringParam, ""),
    deviceModel: withDefault(StringParam, ""),
    deviceUdid: withDefault(StringParam, ""),
    ipAddress: withDefault(StringParam, ""),
    userProvider: withDefault(StringParam, ""),
    deviceOs: withDefault(StringParam, ""),
    appName: withDefault(StringParam, ""),
    menu: withDefault(StringParam, ""),
    screenCodes: withDefault(StringParam, ""),
    actionCodes: withDefault(StringParam, ""),
    countryCode: withDefault(StringParam, ""),
    is_active: withDefault(StringParam, ""),
    userType: withDefault(StringParam, ""),
    userLoginType: withDefault(StringParam, ""),
    startDate: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    endDate: withDefault(
      StringParam,
      formatDateStringToUTC(
        moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
      )
    ),
    type: withDefault(StringParam, ""),
  });

  const [user_nicknameSearch, setNicknameSearch] = useState<string>(
    query?.userNickname || ""
  );

  const [phoneNumberSearch, setPhoneNumberSearch] = useState<string>(
    query?.phoneNumber || ""
  );

  const [user_emailSearch, setuser_emailSearch] = useState<string>(
    query?.userEmail || ""
  );
  const [addressSearch, setAddressSearch] = useState<string>(
    query?.address || ""
  );

  const [IPSearch, setIPSearch] = useState<string>(query?.ipAddress || "");
  const [deviceModelSearch, setDeviceModelSearch] = useState<string>(
    query?.deviceModel || ""
  );
  const [uuidSearch, setUUIDSearch] = useState<string>(query?.deviceUdid || "");

  const [platFormSearch, setPlatFormSearch] = useState<Option | null>(
    LIST_OPTION_PLATFORM?.filter(
      (item) => String(item?.value) === String(query?.userProvider)
    )[0]
  );
  const [oSSearch, setOSSearch] = useState<any | null>(
    LIST_OPTION_OS?.filter(
      (item) => String(item?.value) === String(query?.deviceOs)
    )[0]?.value || ""
  );
  const [isGuestSearch, setIsGuestSearch] = useState<any>(
    USER_TYPE_LOG_OPTION?.find((item) => item?.value === query?.userType)
      ?.value ?? ""
  );
  const [loginTypeSearch, setLoginTypeSearch] = useState<any>(
    USER_TYPE_LOG_OPTION?.find((item) => item?.value === query?.userLoginType)
      ?.value ?? ""
  );
  const [typeSearch, setTypeSearch] = useState<Option | any>(
    LIST_USER_LOG_TYPE_OPTION?.find((item) => item?.value === query?.type)
      ?.value ?? ""
  );
  const [screenCodeSearch, setScreenCodeSearch] = useState<any>({
    label: t("All Filter"),
    value: "all",
  });
  const [actionCodeSearch, setaction_codeSearch] = useState<any>({});

  const [dateSearch, setDateSearch] = useState<any[]>([
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
  ]);
  const [startDate, endDate] = dateSearch;

  const [linkImage, setLinkImage] = useState<any>("");
  const [countrySearch, setCountrySearch] = useState<any | null>(null);
  const [listCountry, setListCountry] = useState<any>([]);
  const [isMultiScreen, setIsMultiScreen] = useState<boolean>(false);

  const selectLayoutState = (state: any) => state.EventLog;
  const EventLogProperties = createSelector(selectLayoutState, (state) => ({
    eventLogs: state.eventLogs,
    isEventLogLoading: state.isEventLogLoading,
    isEventLogSuccess: state.isEventLogSuccess,

    error: state.error,
  }));

  // Inside your component
  const { eventLogs, isEventLogLoading } = useSelector(EventLogProperties);

  function loadTableData() {
    dispatch(getEventLogs(query));
  }

  useEffect(() => {
    loadTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, JSON.stringify(query)]);

  function getKeyByValueModel(value: string) {
    return Object.keys(IPHONE_MODELS).find(
      (key) => IPHONE_MODELS[key as keyof typeof IPHONE_MODELS] === value
    ) || value;
  }

  const searchData = () => {
    let screenCode = '';
    let deviceModel = '';
    if (screenCodeSearch instanceof Array && screenCodeSearch?.length > 0) {
      screenCode = screenCodeSearch?.map((item: any) => (item?.value)).join(",")
    } else if (screenCodeSearch?.value) {
      screenCode = screenCodeSearch?.value
    }

    if(deviceModelSearch) {
      deviceModel = getKeyByValueModel(deviceModelSearch);
    }

    setQuery({
      ...query,
      userNickname: user_nicknameSearch.trim() || "",
      phoneNumber: phoneNumberSearch.trim() || "",
      userEmail: user_emailSearch.trim() || "",
      address: addressSearch.trim() || "",
      ipAddress: IPSearch.trim() || "",
      deviceModel: deviceModel || "",
      deviceUdid: uuidSearch || "",
      userType: isGuestSearch,
      countryCode: countrySearch?.value || "",
      userProvider: platFormSearch?.value || "",
      deviceOs: oSSearch || "",
      screenCodes: (screenCode !== 'all' && screenCode) ? screenCode : "",
      actionCodes: actionCodeSearch?.value || "",
      type: typeSearch || "",
      userLoginType: loginTypeSearch || "",
      startDate: startDate
        ? formatDateStringToUTC(
          moment(new Date(startDate))
            .startOf("day")
            .format("Y-MM-DD HH:mm:ss")
        )
        : "",
      endDate: endDate
        ? formatDateStringToUTC(
          moment(new Date(endDate)).endOf("day").format("Y-MM-DD HH:mm:ss")
        )
        : "",
      //sortBy: TYPE_SELECT_DEFAULT,
      page: 1,
      time_request: +new Date(),
    });
  };

  const resetData = () => {
    setQuery(
      {
        userNickname: "",
        phoneNumber: "",
        userEmail: "",
        address: "",
        ipAddress: "",
        deviceModel: "",
        deviceUdid: "",
        startDate: formatDateStringToUTC(
          moment(new Date()).startOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        endDate: formatDateStringToUTC(
          moment(new Date()).endOf("day").format("Y-MM-DD HH:mm:ss")
        ),
        userType: "",
        userProvider: "",
        countryCode: "",
        deviceOs: "",
        userLoginType: "",
        screenCodes: "",
        actionCodes: "",
        ip: "",
        type: "",
        sortBy: "",
        time_request: +new Date(),
        page: 1,
      },
      "push"
    );
    setNicknameSearch((_prev) => "");
    setPhoneNumberSearch((_prev) => "");
    setuser_emailSearch((_prev) => "");
    setAddressSearch((_prev) => "");
    setIPSearch((_prev) => "");
    setLoginTypeSearch("");
    setDeviceModelSearch((_prev) => "");
    setUUIDSearch((_prev) => "");
    setIsGuestSearch("");
    setPlatFormSearch((_prev) => null);
    setOSSearch(null);
    setIsMultiScreen(false);
    setScreenCodeSearch((_prev: any) => ({
      label: t("All Filter"),
      value: "all",
    }));
    setaction_codeSearch((_prev: any) => null);
    setCountrySearch((_prev: any) => null);
    setDateSearch([
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
      moment(new Date(), "Y-MM-DD HH:mm:ss").toDate(),
    ]);
    setTypeSearch("");
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 60,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div style={{ width: 50 }}>
              {eventLogs?.pagination?.total -
                ((query?.page - 1) * query?.limit + props?.row?.index)}
            </div>
          );
        },
      },

      {
        Header: t("Screen"),
        accessor: "event.screenCode",
        filterable: false,
        sortable: false,
        thWidth: 160,
        thClass: "text-center",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div style={{ minWidth: 140 }} className="text-center">
              <div
                className="rounded-pill badge"
                style={{ background: "#007BFF" }}
              >
                {t(
                  SCREEN_CONST?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label ||
                  status ||
                  ""
                )}
              </div>
            </div>
          );
        },
      },

      {
        Header: t("Event"),
        accessor: "event.actionCode",
        filterable: false,
        sortable: false,
        thWidth: 240,
        thClass: "text-center",
        Cell: (cell: any) => {
          const screenCode = cell?.row?.original?.event?.screenCode;
          const actionCode = cell?.value;
          const EVENT_OPTIONS = SCREEN_CONST?.find(
            (i: any) => i?.value == screenCode
          )?.children;

          return (
            <div style={{ minWidth: 200 }} className="text-center">
              {
                actionCode ? (
                  <div
                    className="rounded-pill badge cursor-pointer"
                    style={{ background: "#4DA3FF" }}
                  >
                    {t(
                      EVENT_OPTIONS?.find(
                        (item: any) => String(item?.value) === String(actionCode)
                      )?.label ||
                      actionCode ||
                      ""
                    )}
                  </div>
                ) : (
                  "-"
                )
              }
            </div>
          );
        },
      },

      {
        Header: t("User Type"),
        accessor: "user.type",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const status = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              <span
                className={`rounded-pill badge bg-${COLOR_USER_TYPE_LOG[status] || "secondary"
                  }`}
              >
                {t(
                  USER_TYPE_LOG_OPTION?.find(
                    (item: any) => String(item?.value) === String(status)
                  )?.label || ""
                )}
              </span>
            </div>
          );
        },
      },

      {
        Header: t("Login Type"),
        accessor: "user.loginType",
        filterable: false,
        sortable: false,
        thWidth: 140,
        thClass: "text-center whitespace-nowrap",
        Cell: (cell: any) => {
          const loginType = cell?.value;
          return (
            <div className="text-center" style={{ minWidth: 80 }}>
              {
                loginType ? (
                  <span
                    className={`rounded-pill badge bg-${COLOR_LOGIN_TYPE_LOG[loginType] || "secondary"
                      }`}
                  >
                    {t(
                      USER_LOGIN_TYPE_OPTION?.find(
                        (item: any) => String(item?.value) === String(loginType)
                      )?.label || ""
                    )}
                  </span>
                ) : "-"
              }
            </div>
          )
        },
      },
      {
        Header: t("Photo"),
        accessor: "user.imageUrls",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 100,
        Cell: (cell: any) => {
          const profileImage = cell?.value?.[0];

          return <div className="w-100 text-center " style={{ minWidth: "60px" }}>
              <div
                style={{ width: "45px" }}
                className="m-auto cursor-pointer"
                onClick={() => setLinkImage({ url: profileImage })}
              >
                <img
                  src={profileImage ?? noImageJob}
                  className="rounded-circle avatar-sm"
                  alt="thumbnail"
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = noImageJob;
                  }}
                />
              </div>
            </div>
        },
      },

      {
        Header: t("Nickname"),
        accessor: "user.nickname",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            cell?.value ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={cell?.value}>
                  {`${cell?.value}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("Phone Number"),
        accessor: "phoneNumber",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          const userType = item?.user?.type;
          let phoneNumber = item?.user?.phoneNumber || "";

          if(userType === 'MANAGER') { 
            phoneNumber = item?.store?.managerPhoneNumber || "";
          }

          return (
            phoneNumber ? (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={phoneNumber}>
                  {`${phoneNumber}`}
                </CopyWrapper>
              </div>
            ) : "-"
          );
        },
      },

      {
        Header: t("Email"),
        accessor: "user.email",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          return (
            <div className="cursor-pointer">
              <CopyWrapper contentCopy={cell?.value}>
                {`${cell?.value || "-"}`}
              </CopyWrapper>
            </div>
          );
        },
      },
      {
        Header: t("Platform"),
        accessor: "user.provider",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          let userProvider = cell?.value;
          let imgPlatform = getPlatFormImage(userProvider);
          return userProvider ? (
            <div className="d-flex flex-column gap-1">
              <div className="cursor-pointer d-flex gap-2 align-items-center whitespace-nowrap">
                <div style={{ width: "25px" }}>
                  {imgPlatform && (
                    <img
                      src={imgPlatform}
                      width={25}
                      height={25}
                      alt="userProvider"
                    />
                  )}
                </div>
                <div className="cursor-pointer">
                  {t(
                    capitalizeFirstLetter(
                      userProvider === "default" || userProvider == "guest"
                        ? "Email"
                        : (
                          LIST_OPTION_PLATFORM?.find((item: any) => item?.value === userProvider)?.label || ""
                        )
                    )
                  )}
                </div>
              </div>
            </div>
          ) : "-"
        },
      },

      {
        Header: t("deviceOS"),
        accessor: "device.os",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 140,
        Cell: (cell: any) => {
          const deviceOS = cell?.value;
          let imgOS = getPlatFormImage(deviceOS);

          return (
            deviceOS && (
              <div
                className="d-flex align-items-center"
                style={{ minWidth: "110px" }}
              >
                {imgOS ? (
                  <div style={{ width: "25px" }} className="me-1">
                    {imgOS ? (
                      <img src={imgOS} width={20} height={20} alt="platform" />
                    ) : (
                      <span
                        className={`bg-secondary`}
                        style={{
                          width: "20px",
                          height: "20px",
                          borderRadius: "3px",
                        }}
                      ></span>
                    )}
                  </div>
                ) : (
                  ""
                )}
                <div>
                  {t(
                    LIST_OPTION_OS?.find((item) => item?.value === deviceOS)
                      ?.label ?? ""
                  )}
                </div>
              </div>
            )
          );
        },
      },

      {
        Header: t("Device Model"),
        accessor: "device.model",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 160,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          let deviceModel = cell.value;
          const os = item?.device?.os;
          if (os === 'ios') {
            deviceModel = deviceModel ? (IPHONE_MODELS[deviceModel as keyof typeof IPHONE_MODELS] ?? deviceModel) : '';
          }

          return (
            deviceModel && (
              <CopyWrapper contentCopy={t(`${deviceModel}`)} style={{ width: 150 }}>
                {t(`${deviceModel}`)}
              </CopyWrapper>
            )
          );
        },
      },

      {
        Header: t("Manufacturer"),
        accessor: "device.manufacturer",
        filterable: true,
        sortable: false,
        thWidth: 170,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const manufacturer = cell?.value;
          return (
            manufacturer && (
              <div className="cursor-pointer" style={{ minWidth: "140px" }}>
                <CopyWrapper contentCopy={manufacturer}>
                  {`${manufacturer}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("UDID"),
        accessor: "device.udid",
        filterable: true,
        sortable: false,
        thWidth: 220,
        thClass: "whitespace-nowrap",
        Cell: (cell: any) => {
          const udid = cell?.value;
          return udid ? (
            <div className="cursor-pointer" style={{ minWidth: "200px" }}>
              <CopyWrapper contentCopy={udid}>
                {`${udid}`}
              </CopyWrapper>
            </div>
          ) : "-";
        },
      },

      {
        Header: t("App Version"),
        accessor: "app",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 120,
        Cell: (cell: any) => {
          const app = cell?.value;
          const appVersion = app?.build
            ? `${app?.version} (${app?.build})`
            : app?.version;
          return (
            appVersion && (
              <div className="cursor-pointer" style={{ minWidth: "110px" }}>
                <CopyWrapper contentCopy={appVersion}>
                  {`${appVersion}`}
                </CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("IP"),
        accessor: "address.ip",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const ip = cell?.value;
          return (
            ip && (
              <div className="cursor-pointer">
                <CopyWrapper contentCopy={ip}>{`${ip}`}</CopyWrapper>
              </div>
            )
          );
        },
      },

      {
        Header: t("Location"),
        accessor: "location",
        filterable: true,
        sortable: false,
        thClass: "whitespace-nowrap",
        thWidth: 180,
        Cell: (cell: any) => {
          const item = cell?.value;
          const lat = item?.coordinates?.[1];
          const lng = item?.coordinates?.[0];

          return lat || lng ? (
            <div className="cursor-pointer" style={{ minWidth: "100px" }}>
              <a
                href={`https://www.google.com/maps/search/${lat},${lng}/@${lat},${lng},17z?entry=ttu`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {item?.address || item?.shortAddress ? (
                  <>{item?.shortAddress ?? item?.address}</>
                ) : (
                  <span className="d-flex align-items-center gap-1">
                    <i className="ri-map-pin-line"></i> {t("Location")}
                  </span>
                )}
              </a>
            </div>
          ) : (
            <></>
          );
        },
      },
      {
        Header: t("Country"),
        accessor: "address.countryCode",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 140,
        Cell: (cell: any) => {
          const countryCode = cell?.value;
          const country = countries.find((item) => item?.code === countryCode);

          return (
            countryCode && (
              <div
                className="d-flex flex-column gap-1"
                style={{ minWidth: "130px" }}
              >
                {
                  <div className="cursor-pointer d-flex gap-2 align-items-center ">
                    {country && (
                      <>
                        <img
                          src={country?.flags}
                          width={20}
                          height={20}
                          alt="profile"
                        />
                        <div className="cursor-pointer">
                          {i18n?.language === "ko"
                            ? country?.name_korea
                            : country?.name}
                        </div>
                      </>
                    )}
                  </div>
                }
              </div>
            )
          );
        },
      },

      {
        Header: t("Created at"),
        accessor: "event.actedAt",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "100px" }}>
              <span>
                <span>{arrDate?.[0] || ""}</span> <br />{" "}
                <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
              </span>
            </div>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i18n?.language, eventLogs?.pagination?.total, query?.page]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChangePicker = (values: any[] = []) => {
    setDateSearch((_prev: any) => values);
  };

  const checkHasAllOption = (lstUsers: any) => {
    let allUser = null;
    if (lstUsers instanceof Array) {
      allUser = lstUsers?.find((e: any) => e?.value == "all")
    }

    return allUser;
  }

  const handleSelectedScreenCode = (e: any) => {
    const allToken = checkHasAllOption(e);
    if (allToken) {
      setScreenCodeSearch(allToken)
    } else {
      setScreenCodeSearch(e)
    }
  }

  useEffect(() => {
    document.title = `${t("Event Log")} | OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  useEffect(() => {
    const handleCallAllOption = async () => {
      try {
        const [resCountry]: any = await Promise.all([
          eventLogApi.countries({ page: 1, limit: 500 }),
        ]);
        setListCountry((_prev: any) => resCountry?.data || []);
      } catch (error: any) {
        return error;
      }
    };

    handleCallAllOption();
  }, []);

  const onCloseImageClick = () => {
    setLinkImage("");
  };

  const screenOptionsLang = SCREEN_CONST.map((i: any) => {
    return { ...i, label: t(i?.label) };
  });

  const allDefaultEvent = [
    ...JOB_POST_SCREEN_CONST,
    ...JOB_POST_DETAIL_SCREEN_CONST,
    ...FIND_TALENT_SCREEN_CONST,
    ...MANAGER_RECRUITMENT_SCREEN_CONST,
    ...PAYMENT_AMOUNT_SCREEN_CONST,
    ...COMMUNITY_SCREEN_CONST,
    ...COMMUNITY_DETAIL_SCREEN_CONST,
    ...PROFILE_RECRUITMENT_SCREEN_CONST,
    ...PROFILE_JOB_SEEKER_SCREEN_CONST,
    ...ADULT_VERIFICATION_SCREEN_CONST,
    // ...LOGIN_SCREEN_CONST,
    ...SETTING_SCREEN_CONST,
    ...APP_INFO_SCREEN_CONST,
    ...FAQ_SCREEN_CONST,
    ...NOTIFICATION_SETTING_SCREEN_CONST,
    ...INQUIRY_SCREEN_CONST
  ];

  const uniqueArray = allDefaultEvent.filter(
    (obj, index, self) =>
      index ===
      self.findIndex((o) => o.value === obj.value && o.label === obj.label)
  );

  const [eventOption, setEventOption] = useState<any>([]);

  useEffect(() => {
    const eventByScreen2 = SCREEN_CONST?.filter((i: any) => {
      let data = '';
      if (screenCodeSearch instanceof Array) {
        data = screenCodeSearch?.find((e: any) => e?.value === i?.value)
      } else if (i?.value === screenCodeSearch?.value) {
        data = screenCodeSearch
      }

      return data;
    });

    const dataEventOption = eventByScreen2?.length > 0 ? eventByScreen2.flatMap((categories) => categories.children) : uniqueArray;


    const eventLang = dataEventOption.map((i: any) => {
      return { ...i, label: t(i?.label) };
    });

    setEventOption(eventLang);

  }, [screenCodeSearch, i18n?.language]);


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t("Event Log")} pageTitle={t("Home")} />
          <Row>
            <Col lg={12}>
              <Card
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title d-flex flex-wrap gap-1 gap-xxl-2 mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          {(isEventLogLoading && query?.page === 1) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                            start={0}
                            end={eventLogs?.pagination?.total || 0}
                            duration={1}
                            className="text-primary"
                          />)}
                          <span className="text-muted">|</span>
                          <span className="d-flex">
                            <div className="me-2">{t('User')}:</div>
                            {(isEventLogLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                              start={0}
                              end={eventLogs?.numOfUsers || 0}
                              duration={1}
                              className="text-primary"
                            />)}
                          </span>
                        </h5>
                      </div>
                    </div>
                  </Row>
                </CardHeader>
                <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                  <CollapseFilter>
                    <Row className="g-4 align-items-center mt-0 mt-md-2">
                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Nickname")}`}
                          isShow={!!user_nicknameSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Nickname")}...`}
                            value={user_nicknameSearch}
                            onChange={(e) => setNicknameSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Email")}`}
                          isShow={!!user_emailSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Email")}...`}
                            value={user_emailSearch}
                            onChange={(e) =>
                              setuser_emailSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Phone Number")}`}
                          isShow={!!phoneNumberSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Phone Number")}...`}
                            value={phoneNumberSearch}
                            onChange={(e) => setPhoneNumberSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper label={`${t("IP")}`} isShow={!!IPSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("IP")}...`}
                            value={IPSearch}
                            onChange={(e) => setIPSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-2"
                      >
                        <LabelWrapper
                          label={`${t("Device Model")}`}
                          isShow={!!deviceModelSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Device Model")}...`}
                            value={deviceModelSearch}
                            onChange={(e) =>
                              setDeviceModelSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("UDID")} isShow={!!uuidSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("UDID")}...`}
                            value={uuidSearch}
                            onChange={(e) => setUUIDSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper
                          label={`${t("Address")}`}
                          isShow={!!addressSearch}
                        >
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t("Address")}...`}
                            value={addressSearch}
                            onChange={(e) => setAddressSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Platform")} isShow={true}>
                          <DropdownPlatform
                            name="userProvider"
                            placeholder={`${t("Platform")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={platFormSearch || null}
                            onChangeSelect={(e: any) => setPlatFormSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("OS")} isShow={true}>
                          <DropdownOptionImage
                            name="deviceOs"
                            dataList={LIST_OPTION_OS || []}
                            placeholder={`${t("OS")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={oSSearch || ""}
                            onChangeSelect={(e: any) => setOSSearch(e?.value)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Country")} isShow={true}>
                          <DropdownCountries
                            name="countryCode"
                            dataList={listCountry || []}
                            placeholder={`${t("Select Country")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={countrySearch || null}
                            onChangeSelect={(e: any) => setCountrySearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("User Type")} isShow={true}>
                          <DropdownStatusNew
                            name="type-user"
                            dataList={USER_TYPE_NOTICE_OPTION || []}
                            placeholder={`${t("User Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={isGuestSearch}
                            onChangeSelect={(e: any) =>
                              setIsGuestSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_USER_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Login Type")} isShow={true}>
                          <DropdownStatusNew
                            name="login-type"
                            dataList={USER_LOGIN_TYPE_OPTION || []}
                            placeholder={`${t("Login Type")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={loginTypeSearch}
                            onChangeSelect={(e: any) =>
                              setLoginTypeSearch(e?.value)
                            }
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                            colors={COLOR_LOGIN_TYPE_LOG}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Screen")} isShow={true}>
                          <DropdownOptionMulti
                            name="screenCode"
                            dataList={screenOptionsLang}
                            placeholder={`${t("Select Screen")}...`}
                            initialValue={screenCodeSearch || null}
                            onChangeSelect={(e: any) => {
                              if (e?.length === 0 || e?.value === 'all') {
                                setIsMultiScreen(false)
                                setScreenCodeSearch({
                                  label: t("All Filter"),
                                  value: "all",
                                })
                              } else {
                                handleSelectedScreenCode(e);
                                setIsMultiScreen(checkHasAllOption(e) ? false : true)
                              }
                            }}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "all" }}
                            isMulti={isMultiScreen}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-3 mt-md-3"
                      >
                        <LabelWrapper label={t("Event")} isShow={true}>
                          <DropdownOption
                            name="actionCode"
                            dataList={eventOption}
                            placeholder={`${t("Event")}...`}
                            className="dropdown-status-rounded"
                            classNamePrefix="name-prefix"
                            initialValue={actionCodeSearch || null}
                            onChangeSelect={(e: any) => setaction_codeSearch(e)}
                            isHasOptionAll={true}
                            optionAll={{ label: t("All Filter"), value: "" }}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        xl={3}
                        xxl={3}
                        className="mt-sm-3 mt-md-3 mt-3 date-picker-wrapper-custom"
                      >
                        <LabelWrapper
                          label={t("Date")}
                          isShow={!!startDate || !!endDate}
                        >
                          <DatePickerCustom
                            startDate={startDate || null}
                            endDate={endDate || null}
                            onChangePicker={handleChangePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col
                        sm={12}
                        md={3}
                        lg={3}
                        className="hstack gap-1 justify-content-center justify-content-md-end mt-sm-4 mt-md-3"
                      >
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-1"
                            onClick={searchData}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t("Button Search")}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t("Button Reset")}
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </CollapseFilter>
                </div>
                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed sticky-table-event-log-media"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={eventLogs?.list?.length ? eventLogs?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={eventLogs?.pagination?.total}
                      customPageCount={Math.ceil(
                        Number(eventLogs?.pagination?.total) / Number(query.limit)
                      )}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isEventLogLoading}
                    />
                  </div>
                  <ToastContainer closeButton={false} limit={1} />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <ModalPreview
          type={linkImage?.isVideo ? "VIDEO" : "IMAGE"}
          isOpen={!!linkImage?.url}
          url={linkImage?.url}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />

        <ModalMultiPreview
          isOpen={!!linkImage?.urls}
          urls={linkImage?.urls || []}
          content={linkImage?.content}
          onClose={() => onCloseImageClick()}
        />
      </div>
    </React.Fragment>
  );
};

export default EventLogList;
